
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 27581,
	"./src/blueslip.ts": 67040,
	"./src/blueslip_stacktrace.ts": 33622,
	"./src/bundles/common.ts": 35013,
	"./src/csrf.ts": 1156,
	"./src/sentry.ts": 333,
	"./styles/portico/collaborychat_landing.css": 26026,
	"./templates/blueslip_stacktrace.hbs": 97825,
	"@sentry/conventions/attributes": 59966,
	"core-js/modules/es.array.includes.js": 54508,
	"core-js/modules/es.array.push.js": 94361,
	"core-js/modules/es.iterator.constructor.js": 16608,
	"core-js/modules/es.iterator.map.js": 72542,
	"core-js/modules/es.json.parse.js": 9999,
	"core-js/modules/es.json.stringify.js": 27761,
	"core-js/modules/es.map.get-or-insert-computed.js": 47180,
	"core-js/modules/es.map.get-or-insert.js": 40870,
	"error-stack-parser": 69363,
	"handlebars/runtime.js": 38417,
	"jquery": 63150,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021
};